import { PartialNullable } from "../Extensions";
import { IRadObject, Property, RadObject, RadObjectPropertyValues } from "../RadObject";
import { NAMESPACE } from "./_Namespace";

class HttpHeaderParameter
{
    public name?: string;
    public value?: string;
}

class HttpHeader
{
    public name?: string;
    public parameters: HttpHeaderParameter[] = [];
    public value?: string;
}


export type HttpHeaderManagerPropertyValues =
    RadObjectPropertyValues
    & {
    };

export type HttpHeaderManagerProperties = {
    [name in keyof HttpHeaderManagerPropertyValues]: Property<HttpHeaderManagerPropertyValues[name]>
};

export interface IHttpHeaderManager extends IRadObject, HttpHeaderManagerProperties
{
}

export class HttpHeaderManager extends RadObject implements IHttpHeaderManager
{
    public static override classNamespace = NAMESPACE + "HttpHeaderManager";
    public static override className = "HttpHeaderManager";

    // #region Global Variables

    public headerText?: string;
    public headers: HttpHeader[] = [];

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<HttpHeaderManagerPropertyValues>)
    {
        super(propertyValues);

        this.headers = [];
    }

    // #endregion

    // #region Public Methods

    public getHeader(headerName: string)
    {
        for (let i = 0; i < this.headers.length; i++)
        {
            if (this.headers[i].name?.toLowerCase() === headerName.toLowerCase())
                return this.headers[i];
        }

        return null;
    }
    public getHeaderParameterValue(headerName: string, parameterName: string)
    {
        const
            header = this.getHeader(headerName);

        if (header === null)
            return null;

        for (let i = 0; i < header.parameters.length; i++)
        {
            if (header.parameters[i].name?.toLowerCase() === parameterName.toLowerCase())
                return header.parameters[i].value;
        }
    }
    public setHeaderText(headerText: string)
    {
        // TODO: Enhance to take quoted identifiers into consideration.

        this.headerText = headerText;
        this.headers = [];

        const
            lines = headerText.split("\r\n");

        for (let i = 0; i < lines.length; i++)
        {
            let
                line = lines[i].trim();

            if (!line.length)
                continue;

            const
                header = new HttpHeader(),
                indexOfColon = line.indexOf(":");

            header.name = (indexOfColon >= 0 ? line.substring(0, indexOfColon) : line).trim();
            this.headers.push(header);

            if (indexOfColon === -1)
                continue;

            line = line.substring(indexOfColon + 1);

            const
                indexOfSemiColon = line.indexOf(";");

            header.value = (indexOfSemiColon >= 0 ? line.substring(0, indexOfSemiColon) : line).trim();
            line = line.substring(indexOfSemiColon + 1);

            if (indexOfSemiColon === -1)
                continue;

            const
                additionalParameters = line.split(";");

            for (let j = 0; j < additionalParameters.length; j++)
            {
                const
                    parameter = new HttpHeaderParameter(),
                    additionalParameter = additionalParameters[j],
                    indexOfEquals = additionalParameter.indexOf("=");

                parameter.name = (indexOfEquals >= 0 ? additionalParameter.substring(0, indexOfEquals) : additionalParameter).trim();
                header.parameters.push(parameter);

                if (indexOfEquals === -1)
                    continue;

                parameter.value = additionalParameter.substring(indexOfEquals + 1).trim();
            }
        }
    }

    // #endregion
}